import Model from '@ember-data/model';
import { Promise } from 'rsvp';
import Service, { inject as service } from '@ember/service';
import { handleErrorResponseWithModal } from 'sh-www/utils/handles-errors';

/**
 * Service for pitch related API calls.
 */
export default Service.extend({
  api: service(),
  store: service(),
  shData: service(),

  /**
   * @param {DS.Model|string} assignment
   * @param {Object} params
   * @param {string[]} opt_includes
   */
  createPitch(assignment, params, opt_includes = []) {
    const assignment_id = (assignment instanceof Model) ? assignment.get('id') : assignment;

    const options = {
      jsonData: Object.assign({ assignment_id }, params),
    };

    this.shData.addIncludesToOptions(options, opt_includes);

    return this.get('api').post('pitches/', options).then((response) => {
      const store = this.get('store');
      store.pushPayload(response);
      return store.peekRecord('pitch', response.data.id);
    });
  },
  /**
   * delete the image on the pitch passed in.
   *
   * @param {Pitch} pitch
   * @param {Array<String>} opt_includes
   * @return {Ember.RSVP.Promise}
   */
  deletePitchImage(pitch, opt_includes = []) {
    let options = this.shData.addIncludesToOptions({}, opt_includes);

    return new Promise((resolve, reject) => {
      this.get('api').delete(`pitches/${pitch.get('id')}/images/${pitch.get('image.id')}/`, options).then(response => {
        pitch.set('image', null);
        resolve(true);
      }).catch((e) => {
        handleErrorResponseWithModal(
          this,
          e,
          'There was an error deleting your image. Please refresh and try again.',
          'deletePitchImage -- error updating pitch id: ' + pitch.get('id'),
        );
        reject(e);
      });
    });
  },

  /**
   * Update a pitch with the given props.
   *
   * @param {Pitch} pitch
   * @param {Object} propsToUpdate
   * @param {Array<String>=} opt_includes
   * @return {Ember.RSVP.Promise}
   */
  updatePitch(pitch, propsToUpdate, opt_includes = []) {
    let options = {
      jsonData: propsToUpdate
    };

    options = this.shData.addIncludesToOptions(options, opt_includes);

    return this.api.put(`pitches/${pitch.id}/`, options).then(response => {
      this.shData.pushResponseToStore(response)
      return this.store.peekRecord('pitch', response.data.id)
    }).catch((e) => {
        handleErrorResponseWithModal(
          this,
          e,
          'There was an error updating your pitch. Please refresh and try again.',
          'updateApplication -- error updating pitch id: ' + pitch.id + ' props: ' + JSON.stringify(propsToUpdate),
        );
        throw e;
    });
  }
});
